import styled from "styled-components";

export const ContainerDashboard = styled.section`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: hidden;

    div.Dashboard__filter__container {
        width: 100%;
        height: 90px;
        position: sticky;
        top: 0px;
        display: flex;
        justify-content: space-between;
        z-index: 200;

        div.Dashboard__filter {
            margin-top: -10px;
            background: #fff;
            display: flex;
            align-self: flex-start;
            align-items: center;
            box-sizing: border-box;
            padding: 10px;
            border-radius: 15px;
            position: sticky;
            top: 0px;
            z-index: 999;
            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        }

        div.Dashboard__filter__segments {
            margin-top: -10px;
            background: #fff;
            display: flex;
            align-self: flex-start;
            align-items: center;
            box-sizing: border-box;
            padding: 10px;
            border-radius: 15px;
            position: sticky;
            top: 0px;
            z-index: 999;
            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
        }
    }

    

    div.ContainerDashboard__content {
        width: 100%;
        height: calc(100vh - 180px);
        overflow-y: auto;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }
 
`;